import Horn from '@mtfe/horn-sdk';
import { env, request, bridge, runtime } from '@/common';
import { EventBus } from './eventBus';

export function handleAppear(callback: () => void) {
  bridge.unSubscribe('appear', () => {
    bridge.setNavigationBarHidden();
    // 不同业务的业务方法
    callback();
  });
}

export function fetchMainpageData(): Promise<any> {
  return new Promise((resolve) => {
    request.getMainPage((data: any) => {
      env.setIndexData(data);
      EventBus.$emit('updatePageData');
      resolve(data);
    });
  });
}

export function fetchLatestBalance(): Promise<any> {
  return new Promise((resolve) => {
    request
      .fetchLatestBalanceDetail()
      .then((res) => {
        EventBus.$emit('setLatestBalanceDetail', res.data);
        resolve(res);
      })
      .catch(() => {
        EventBus.$emit('setLatestBalanceDetail', {});
        resolve({});
      });
  });
}

export function prefetchApiWithTimeout(url: string): Promise<any> {
  const reportUrl = url.split('/').pop();
  return new Promise((resolve, reject) => {
    let apiPrefetchCallbackSuccess = false;
    const timeoutId = setTimeout(() => {
      if (!apiPrefetchCallbackSuccess) {
        reject(new Error(`${reportUrl}接口预取超时`));
      }
    }, 2000);
    ehPrefetchApi(url)
      .then((res: any) => {
        clearTimeout(timeoutId); // 清除超时逻辑
        if (res.statusCode === 200) {
          apiPrefetchCallbackSuccess = true;
          resolve(JSON.parse(res.data));
        } else {
          reject(new Error(`${reportUrl}调用ehApi-status-fail`));
        }
      })
      .catch(() => {
        clearTimeout(timeoutId); // 清除超时逻辑
        apiPrefetchCallbackSuccess = true;
        reject(new Error(`${url}调用ehApi-fail-callback`));
      });
  });
}

export function ehPrefetchApi(url: string) {
  return new Promise((resolve, reject) => {
    KNB.use('eh.prefetchApi', {
      url,
      success: (res: any) => {
        resolve(res);
      },
      fail: (err: any) => {
        reject(err);
      },
    });
  });
}

export function refreshPage(callback?: () => void) {
  bridge.subscribe('appear', () => {
    handleAppear(() => {
      fetchMainpageData();
      EventBus.$emit('updateBalanceDetail');

      // 更新今日已赚余额数
      EventBus.$emit('updateRewardAmountData');
      if (callback) {
        callback();
      }
    });
  });
}

export function refreshPageSubscribe(callback?: () => void) {
  fetchMainpageData();
  EventBus.$emit('updateBalanceDetail');
  if (callback) {
    callback();
  }
}
export function reportBlackType() {
  const params = {
    blackType: 'CONTINUE_USE_BALANCE',
  };
  request.fetchReportBlackType(params);
}
/**
 * @fn 获取horn配置
 * @params key horn配置key, defaultValue 默认值, params 参数, timeout 超时时间
 */
export function getHorn(key: string, defaultValue: any, params?: any, timeout = 1500): Promise<unknown> {
  Horn.init(
    {},
    {
      isDev: runtime !== 0 && runtime !== 1,
    }
  );
  const delayReject = () => {
    // 用于控制超时后reject
    return new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        reject(new Error(`超时-timeout:${timeout}`));
      }, timeout);
    });
  };
  const options = params || {
    userid: env.queryStrings.userid || env.cookies.userid || env.cookies.userId,
    uuid: env.cookies.uuid,
  };
  return Promise.race([Horn.fetch(key, options, defaultValue), delayReject()]);
}

/**
 * @fn 获取常见问题列表
 */
export function fetchQuestionList() {
  return new Promise((resolve) => {
    getHorn('main-question-list', {
      list: [],
    })
      .then((config: any) => {
        EventBus.$emit('setQuestionList', config);
        resolve(config);
      })
      .catch((err) => {
        EventBus.$emit('setQuestionList', []);
        resolve([]);
      });
  });
}
